import React from 'react';
import SubscriptionsList from '../../components/accounts/SubscriptionsList';
import { mockSubscriptions, mockBills, mockAccounts } from '../../data/mockData';

const SubscriptionsBills: React.FC = () => {
  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold text-gray-900 dark:text-white">Subscription & Bills</h1>
      <SubscriptionsList
        subscriptions={mockSubscriptions}
        bills={mockBills}
        accounts={mockAccounts}
      />
    </div>
  );
};

export default SubscriptionsBills;
